import * as moment from 'moment';
import { addZero } from '../../base/helpers/addZero';
/**
 * Humanize a duration value.
 * @param {any} value The value will be transformed in a duration, if it is not so already.
 * @returns {string} The duration in HH:mm format.
 */
export function durationToText(value) {
    if (!value) {
        return '';
    }
    var duration = moment.isDuration(value) ? value : moment.duration(value);
    if (!duration.isValid()) {
        return '';
    }
    var total = duration.asMinutes();
    var hours = Math.floor(Math.abs(total) / 60);
    var minutes = Math.floor(Math.abs(total) % 60);
    if (total < 0) {
        return '-' + addZero(hours) + ':' + addZero(minutes);
    }
    return addZero(hours) + ':' + addZero(minutes);
}
